export default "__VITE_ASSET__CTS5hfrf__"